import { fetchApi } from "../../tools";

const enviarPago = async (urlCursos, data, headers) => {
    const response = await fetchApi({
        method: "POST",
        headers: headers,
        url: urlCursos + "/inscripciones/paga_cursos",
        content: data
    });
    
    return response;
}


export {
    enviarPago
}